import clsx from 'clsx/lite';
import { Button } from '~/components/Buttons';
import type { AcfLink, AcfMediaItemConnectionEdge } from '~/types/graphql';
import { Container } from './Container';

export function PageHero(props: {
  copy?: string;
  heading?: string;
  subheading?: string;
  link?: AcfLink;
  image?: AcfMediaItemConnectionEdge;
  mobileImage?: AcfMediaItemConnectionEdge;
  team?: string;
  className?: string;
  isDark?: boolean;
  localSponsor?: {
    label: string;
    sponsorLogo: AcfMediaItemConnectionEdge;
  };
}) {
  const {
    heading,
    copy,
    image,
    mobileImage,
    link,
    isDark,
    className,
    subheading,
    localSponsor,
  } = props;

  if (!heading && !copy) return;

  return (
    <div
      className={clsx(
        'flex px-[--site-margin] py-12 lg:pb-16',
        isDark && 'border-b border-current',
        className,
      )}
    >
      <Container className="gap-8 lg:flex-row lg:gap-16">
        <div className="flex w-full flex-col gap-6 lg:max-w-[496px] lg:py-9">
          <h2 className="w-fit font-nova text-[34px] font-black uppercase leading-none lg:text-5xl">
            {heading}
          </h2>
          {!!subheading && (
            <h3 className="my-[-10px] font-nova text-[20px] font-semibold leading-[24px] lg:text-xl lg:leading-[30px]">
              {subheading}
            </h3>
          )}
          {!!mobileImage?.node.sourceUrl && (
            <img
              className="rounded object-cover lg:hidden"
              src={mobileImage.node.sourceUrl}
              alt={mobileImage.node.altText ?? ''}
            />
          )}

          <div className="flex flex-col gap-9 lg:gap-16">
            <div
              className="font-nova text-[16px] font-normal leading-[24px] lg:text-xl lg:leading-[30px]"
              dangerouslySetInnerHTML={{ __html: copy ?? '' }}
            />
            {!!localSponsor?.sponsorLogo?.node.sourceUrl && (
              <div className="mt-[-16px] flex flex-col gap-4 lg:mt-[-32px]">
                <em>{localSponsor.label}</em>
                <img
                  className="w-auto max-w-fit"
                  src={localSponsor.sponsorLogo.node.sourceUrl}
                  alt={localSponsor.sponsorLogo.node.altText ?? ''}
                />
              </div>
            )}
            {!!link?.url && (
              <Button isLarge href={link.url}>
                {link.title}
              </Button>
            )}
          </div>
        </div>
        {!!image?.node.sourceUrl && (
          <div className={clsx('flex', mobileImage && 'max-lg:hidden')}>
            <img
              className="aspect-[188/131] w-full max-w-[752px] rounded object-cover"
              src={image.node.sourceUrl}
              alt={image.node.altText ?? ''}
            />
          </div>
        )}
      </Container>
    </div>
  );
}
